import React, { useMemo } from 'react';
import uniqBy from 'lodash/uniqBy';
import sortBy from 'lodash/sortBy';
import { useQuery } from '@apollo/client';
import { Box, Text, Flex, xcss } from '@atlaskit/primitives';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/temp-client-utils';
import { LoadingIndicator } from '@atlassian/temp-loading-indicator';
import { EntitlementIcon, withApollo } from '@css-xp/base';
import {
  FetchNativeProductCollectionForCatalogueQuery,
  FetchNativeProductCollectionForCatalogueQueryVariables,
} from '@css-xp/graphtypes/src/generated-types-sxp';
import styled from '@emotion/styled';
import { fetchNativeProductCollectionForCatalogue } from '../queries/fetch-native-product-collection-for-catalogue';

export const EntitlementIconStyle = styled.div`
  img {
    width: 100%;
    height: 100%;
  }
  display: flex;
  align-items: center;
`;

export const IncludedProductsSidebar = withApollo(
  ({ productKey, isVersion2 }: { productKey: string; isVersion2: boolean }) => {
    const client = useMemo(() => abgGraphqlClient(ProxyGraphClients.SXP), []);

    const { data: collectionListData, loading: collectionListDataLoading } = useQuery<
      FetchNativeProductCollectionForCatalogueQuery,
      FetchNativeProductCollectionForCatalogueQueryVariables
    >(fetchNativeProductCollectionForCatalogue, {
      client,
      variables: {
        productKey: productKey,
      },
    });

    const includedProductsData = useMemo(() => {
      const includedProducts = collectionListData?.nativeCatalogForCollection?.nodes?.[0]?.productOfferingsForCollection?.map(
        (productOffering) => productOffering?.product
      );
      const uniqueIncludedProductsList = uniqBy(includedProducts, 'id');
      return sortBy(uniqueIncludedProductsList, 'name');
    }, [collectionListData]);

    return (
      <Box paddingBlockStart="space.100">
        <Text weight="bold" size="large">
          Included products
        </Text>
        {collectionListDataLoading ? (
          <LoadingIndicator />
        ) : (
          <Box paddingBlockStart={isVersion2 ? 'space.400' : 'space.100'}>
            <Text weight="bold" size="medium">
              Products ({includedProductsData.length})
            </Text>
            {includedProductsData.map((productDetail) => {
              return (
                <Box paddingBlockStart="space.200" key={productDetail?.id}>
                  <Flex alignItems="center">
                    <Box xcss={xcss({ width: isVersion2 ? '10%' : '15%' })} padding="space.050">
                      <EntitlementIconStyle>
                        <EntitlementIcon
                          productId={productDetail?.id}
                          //   logoId={productDetail?.logoId}
                          isCloud
                        />
                      </EntitlementIconStyle>
                    </Box>
                    <Box paddingInlineStart="space.100">
                      <Text>{productDetail?.name}</Text>
                    </Box>
                  </Flex>
                </Box>
              );
            })}
          </Box>
        )}
      </Box>
    );
  }
);
